import { FC, useEffect, useState } from "react"
import { ChrevonLeftIcon } from "../../components/MenuIcons/ChevrotLeft"
import './create.css'

import { useLocation, useNavigate } from "react-router-dom"
import { Outlet, Route, Routes } from 'react-router-dom'
import { CreateAccount } from "./create/create"
import { ValidateAccount } from "./validate/validate"
import { SuccessPage } from "./success/success"
import { Footer } from "../../components/Footer/footer"


const AccountLayout: FC<any> = () => {

    const navigate = useNavigate()
    const location = useLocation();
    const [show, setShow] = useState(true)



    function shouldShow() {
        const currentPath = location.pathname;
        const pathEnd = currentPath.substring(currentPath.lastIndexOf('/') + 1);

        if (pathEnd === 'success') {
            setShow(false)
        }
        else {
            setShow(true)
        }

    }

    useEffect(() => {
        shouldShow()
    }, [location.pathname])


    return (
        <div className="createPage">
            <div className="createContent">
                <div className="create">
                    <div className="back">
                        <ChrevonLeftIcon action={() => navigate(-1)} />
                    </div>
                   { <Outlet />}
                </div>
                {show && <Footer />}
            </div>
        </div>
    )
}


const AccountPage = () => {

    return (
        <Routes>
            <Route element={<AccountLayout />}>
                <Route path='' element={<CreateAccount />} />
                <Route path='/validation' element={<ValidateAccount />} />
                <Route path='/success' element={<SuccessPage />} />
            </Route>
        </Routes>
    )
}


export { AccountPage }